export default __webpack_public_path__ + "4c0823926ac3bd94358c59c501e8061a.png";